<template>

    <v-row>
      <v-col cols="2">
        <v-btn
            fab
            dark
            small
            color="error"
            @click="castVote(-1)"
        >
          <v-icon dark>
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="8"><div class="text-h5 text-center">Is this a meme?</div> </v-col>
      <v-col cols="2">
        <v-btn
            fab
            dark
            small
            color="success"
            @click="castVote(1)"
        >
          <v-icon dark>
            mdi-check
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

</template>

<script>
export default {
  name: "PotentialMemeVoter",
  methods: {
    castVote(value) {
      this.$emit('cast-vote', value)
    }
  }
}
</script>

<style scoped>

</style>